<template>
	<div class="dashboard-container">
		<div class="waititle" style="display: flex;">
			<div style="flex: 1;display: flex;">
				<div class="blue" />
				商品数据概括
			</div>
			<div class="attributes" style="transform: translate(0,-3px)">
				<div class="attributes_title" style="display: flex;">
					<div style="font-weight: 400;line-height: 30px;">时间筛选：</div>
					<el-select size="small" v-model="user" style="width: 110px;margin-right:10px;" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
					</el-select>
					<el-date-picker size="small" v-model="data" type="date" style="margin-right:10px;"
						placeholder="选择日期" />
					<el-button type="primary" size="small">导出</el-button>
				</div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2">
				<div>流量趋势</div>
				<div class="showlist_top">
					<div v-for="i in 4" :key="i" class="showlist_top1">
						<div>小程序访客数 (UV)</div>
						<div>50000</div>
						<div class="bili">
							<div>
								周同比
								<img src="../../../assets/shangsheng.png" />
								<span style="color: #4B4B4B;">100%</span>
							</div>
						</div>
					</div>
				</div>
				<div class="attributes_bottom"><ve-line legend-position="center" :data="chartData2"
						:extend="typeExted"></ve-line></div>
			</div>
		</div>
		<div class="showlist2s">
			<div class="showlist2" style="padding: 0;">
				<el-table :data="tableData" :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F4F1F4','text-align':'center'}">
					<el-table-column prop="date" align="center" label="时间"></el-table-column>
					<el-table-column prop="name" align="center" label="小程序访问量(pv)"></el-table-column>
					<el-table-column prop="address" align="center" label="小程序访客数(uv)"></el-table-column>
					<el-table-column prop="address" align="center" label="门店访问量"></el-table-column>
					<el-table-column prop="address" align="center" label="门店访客数"></el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagescg"> <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100"
				layout="total, sizes, prev, pager, next, jumper" :total="400">
			</el-pagination></div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				currentPage4: 4, //用于翻页
				chartData_huan: {
					columns: ['日期', '访问用户'],
					rows: [{
						日期: '会员',
						访问用户: 1393
					}, {
						日期: '用户',
						访问用户: 3530
					}, ]
				},
				tableData: [{
					date: '2016-05-02',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1518 弄'
				}, {
					date: '2016-05-04',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1517 弄'
				}, {
					date: '2016-05-01',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1519 弄'
				}, {
					date: '2016-05-03',
					name: '王小虎',
					address: '上海市普陀区金沙江路 1516 弄'
				}],
				chartData2: {
					columns: ['日期', '访问用户', '下单用户', '下单率'],
					rows: [{
						'日期': '1/1',
						'访问用户': 1393,
						'下单用户': 1093,
						'下单率': 0.32
					}, {
						'日期': '1/2',
						'访问用户': 3530,
						'下单用户': 3230,
						'下单率': 0.26
					}, {
						'日期': '1/3',
						'访问用户': 2923,
						'下单用户': 2623,
						'下单率': 0.76
					}, {
						'日期': '1/4',
						'访问用户': 1723,
						'下单用户': 1423,
						'下单率': 0.49
					}, {
						'日期': '1/5',
						'访问用户': 3792,
						'下单用户': 3492,
						'下单率': 0.323
					}, {
						'日期': '1/6',
						'访问用户': 4593,
						'下单用户': 4293,
						'下单率': 0.78
					}]
				},
				typeExted: {
					legend: {
						center: 0,
						icon: "circle",
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 20,
					},
				},
				user: '',
				listtime: '',
				data: '',
				activeName: 'two',
				friendsnum: [{
					name: '累计会员数'
				}],
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				option2: [{
					value: '选项1',
					label: '今天'
				}, {
					value: '选项2',
					label: '明天'
				}, {
					value: '选项3',
					label: '后天'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
			}
		},
		mounted() {},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			handleClick(tab, event) {
				console.log(tab, event)
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.pagescg {
		margin-top: 20px;
		margin-bottom: 40px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		align-items: center;
	}

	.waititle {
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #3e3e3e;

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.showlist_top {
		margin-top: 20px;
		width: 100%;
		height: 145px;
		display: flex;

		.showlist_top1 {
			box-sizing: border-box;
			padding: 20px;
			flex: 1;
			margin-left: 20px;
			background: #f2f2f2;
			border-radius: 6px;

			>div {
				&:nth-child(1) {
					font-size: 14px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #3e3e3e;
				}

				&:nth-child(2) {
					font-size: 20px;
					margin-top: 10px;
					font-size: 36px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #3e3e3e;
				}
			}

			.bili {
				margin-top: 10px;
				display: flex;
				font-size: 14px;

				img {
					width: 10px;
					height: 15px;
					position: relative;
					top: 2px;
				}
			}

			&:nth-child(1) {
				margin: 0;
			}
		}
	}

	.showlist2s {
		width: 100%;
		padding: 4px;
		box-sizing: border-box;
	}

	.showlist2 {
		padding: 20px;
		box-sizing: border-box;
		margin-top: 20px;
		width: 100%;
		background: #ffffff;
		box-shadow: 0px 2px 9px 0px rgba(#0000, 0.09);

		.attributes_bottom {
			margin-top: 30px;
		}
	}
</style>